import { DirectiveBinding } from 'vue/types/options';
import { Translation } from '../contract/translation.contract';
import { translatedPropertyService } from '../shared/i18n/translated-property.service';

interface TranslatedPropertyBinding extends DirectiveBinding {
  value?: Translation;
}

const translatedProperty = (element: HTMLElement, binding: TranslatedPropertyBinding): string => {
  return (binding.value && translatedPropertyService.translateProperty(binding.value)) || '';
};

export default translatedProperty;
